function safeHttpUrl(value) {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined;
  } catch (error) {
    return undefined;
  }
}

export function groundingImages(response) {
  const agentImages = response?.debug?.vtag?.groundingImages || response?.grounding;
  if (Array.isArray(agentImages) && agentImages.length > 0) {
    return agentImages
      .map((item) => {
        const url = safeHttpUrl(
          item?.imageUrl || item?.mediaUrl || item?.attribution_url || item?.attributionUrl,
        );
        const pageUrl = safeHttpUrl(
          item?.pageUrl || item?.source_url || item?.sourceUrl,
        );
        return {
          url,
          previewUrl: url,
          title: item?.caption || item?.title || item?.sourceName || 'Grounding image',
          sourceUrl: pageUrl,
          domain: item?.sourceDomain || item?.domain || item?.sourceName || '',
        };
      })
      .filter((item) => item.url)
      .slice(0, 8);
  }

  const images = response?.mmir_images_grounding
    || response?.mmir_images_aug
    || response?.icg_images
    || [];
  return images
    .map((item) => {
      const url = safeHttpUrl(item?.url || item?.image_url || item?.imageUrl);
      return {
        url,
        previewUrl: url,
        title: item?.source_metadata?.title
          || item?.ims_source_title
          || item?.caption
          || item?.title
          || 'Grounding image',
        sourceUrl: safeHttpUrl(item?.source_url || item?.attribution_url || item?.pageUrl),
        domain: item?.source_metadata?.domain || item?.sourceDomain || item?.sourceName || '',
      };
    })
    .filter((item) => item.url)
    .slice(0, 8);
}
